export enum Verfahren {
    STEP,
    KIWI,
    ZAV
}